/*
 * @Copyright: Copyright (c) Pray LLC. All rights reserved.
 * @Author: Raguvind Tharanitharan
 * @Date: 2022-09-12 10:18:12
 * @Last Modified by: Raguvind Tharanitharan
 * @Last Modified time: 2022-09-12 22:12:00
*/

import React, { createElement } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppBar, Toolbar, Box, IconButton, Divider, Grid } from '@mui/material';
import { Tooltip, Avatar, Menu, MenuItem, ListItemIcon, Typography } from '@mui/material';
import { Launch } from '@mui/icons-material';
import * as MuiIcons from "@mui/icons-material";
import { logoutUser } from '../../common/stores/user';
import { PrayButton } from '../../common';
import EventService from '../../common/services/events-service';

// Resources
import logo from '../resources/logo.svg';
import '../styles/local-style.css';

export default function AppNavigationBar() {
  const settings = useSelector((state) => state.settings);
  const user = useSelector((state) => state.user);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const dispatch = useDispatch();

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleMenuClick = (item) => {
    switch (item.name) {
      case 'Logout':
        EventService.logEvent('User Logged Out', { view_name: 'App Navigation Bar' });
        dispatch(logoutUser());
        break;
      default:
        EventService.logEvent('Tap', { view_name: 'App Navigation Bar', button_name: item.name });
        break;
    }
  };

  const renderMenuItem = (item) => {
    if (item.type === 'Divider') {
      return (<Divider key={item.id} sx={{ m: 3 }} variant="middle" />);
    } else {
      return (
        <MenuItem key={item.id} sx={{ px: 3, py: 1.5 }} onClick={() => { handleMenuClick(item); }} disabled={item.disabled}>
          <ListItemIcon>
            {createElement(MuiIcons[item.icon])}
          </ListItemIcon>
          <Typography variant="h5">{item.name}</Typography>
        </MenuItem>
      );
    }
  };

  // const renderNotification = () => {
  //   return (
  //     <IconButton
  //       size='large'
  //       aria-label='show 17 new notifications'
  //       color='inherit'
  //     >
  //       <Badge badgeContent={settings.notification} color='error' sx={{ "& .MuiBadge-badge": { p: 0.5, pt: 0.6 } }}>
  //         <NotificationsIcon sx={{ color: 'secondary.dark' }} />
  //       </Badge>
  //     </IconButton>
  //   );
  // };

  const renderUserAvatar = (menuList) => {
    return (
      <>
        <Box sx={{ flexGrow: 0 }}>
          <Tooltip title="Your profile and settings">
            <IconButton sx={{ p: 0 }} onClick={handleOpenUserMenu}>
              <Avatar alt={user.name} src={user.picture} sx={{ width: 32, height: 32, mt: 0.9 }} />
            </IconButton>
          </Tooltip>
        </Box>
        <Menu elevation={0} id="menu-appbar"
          sx={{ mt: '35px', '& .MuiPaper-root': { boxShadow: 'var(--ds-shadow-overlay, 0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31))', borderRadius: 0.7, border: '1px solid #3333331c' } }}
          anchorEl={anchorElUser} keepMounted transformOrigin={{ vertical: 'top', horizontal: 'right' }} open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} className="menu-container">
          <Box sx={{ px: 2.5, py: 0.5, pb: 1.5, minWidth: 270 }}>
            <Typography variant="subtitle1">Account</Typography>
          </Box>
          <Grid container sx={{ pb: 1, pl: 2 }}>
            <Avatar alt={user.name} src={user.imageUrl} sx={{ width: 32, height: 32 }} />
            <Grid sx={{ px: 1.5, mb: -10 }}>
              <Typography variant="h5">{user.name}</Typography>
              <Typography variant="h6">{user.email}</Typography>
            </Grid>
          </Grid>
          {menuList != null && menuList.map((item) => renderMenuItem(item))}
        </Menu>
      </>
    );
  };

  return (
    <AppBar position='fixed' sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} elevation={0}>
      {/* <PrayView disableEvent={true}> */}
        <Toolbar color="secondary" className='app-bar' sx={{ backgroundColor: 'secondary.main' }}>
          <img src={logo} alt='Pray data studio' style={{ width: '4%' }} />
          <Box sx={{ flexGrow: 1, px: 5 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            <a rel="noopener noreferrer" href="https://studio.pray.com" target="_blank" style={{ textDecoration: 'none' }}>
              <PrayButton sx={{ textTransform: 'none', mr: 0, pr: 2 }} viewName="App Navigation Bar" text="Pray Studio">
                <Typography variant='h4' sx={{ p: 1, pr: 0.8, mt: 0.3 }}>Pray Studio</Typography>
                <Launch sx={{ color: 'secondary.dark' }} />
              </PrayButton>
            </a>
            {/* {renderNotification()} */}
            <Divider sx={{ mx: 1.5, my: 1 }} orientation="vertical" flexItem />
            {renderUserAvatar(settings.menu)}
          </Box>
        </Toolbar>
      {/* </PrayView> */}
    </AppBar>
  );
};
